import { render, staticRenderFns } from "./OrdersOverviewPartially.vue?vue&type=template&id=57d4a2e3"
import script from "./OrdersOverviewPartially.vue?vue&type=script&lang=js"
export * from "./OrdersOverviewPartially.vue?vue&type=script&lang=js"
import style0 from "./OrdersOverviewPartially.vue?vue&type=style&index=0&id=57d4a2e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports